"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _awsSdk = _interopRequireDefault(require("aws-sdk"));
var emailTemplate = function emailTemplate(businessName, email) {
  return {
    Destination: {
      ToAddresses: ['info@gofisherman.com']
    },
    Message: {
      Subject: {
        Charset: 'UTF-8',
        Data: "Checkout Email Submission"
      },
      Body: {
        Text: {
          Charset: 'UTF-8',
          Data: "\n          ".concat(businessName, " has submitted the following email:\n          ").concat(email, "\n          ")
        }
      }
    },
    Source: 'Website Checkout <info@gofisherman.com>'
  };
};
var emailCallback = function emailCallback(_ref) {
  var businessName = _ref.businessName,
    email = _ref.email;
  return new _awsSdk["default"].SES({
    apiVersion: '2010-12-01'
  }).sendEmail(emailTemplate(businessName, email)).promise();
};
var _default = emailCallback;
exports["default"] = _default;